<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <div class="search">
                <i class="fa-light fa-magnifying-glass" aria-hidden="true"></i>
                <input type="text" [(ngModel)]="search" [placeholder]="'admin_equipment_search_placeholder' | translate"
                    autocomplete="off" />
            </div>
            <button class="add-btn" type="button" (click)="openAdd()">{{ 'admin_equipment_add' | translate }}</button>
        </div>

        @if (loading) {
            <p class="state-text">{{ 'admin_loading' | translate }}</p>
        } @else if (equipment.length === 0) {
            <p class="state-text">{{ 'admin_equipment_empty' | translate }}</p>
        } @else if (filtered.length === 0) {
            <p class="state-text">{{ 'admin_equipment_no_match' | translate }}</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th class="thumb-col"></th>
                            <th>{{ 'equipment_field_code' | translate }}</th>
                            <th>{{ 'field_name' | translate }}</th>
                            <th>{{ 'equipment_field_slug' | translate }}</th>
                            <th class="num-col">{{ 'equipment_field_specs' | translate }}</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of filtered; track item.id) {
                            <tr>
                                <td class="thumb-col">
                                    @if (item.image && !imageBroken(item)) {
                                        <span class="thumb-slot">
                                            @if (imagePending(item)) {
                                                <!-- Holds the slot while the signed S3 URL is still in flight. -->
                                                <span class="thumb-skeleton" aria-hidden="true"></span>
                                            }
                                            <img [src]="item.image" [alt]="item.code" class="thumb"
                                                loading="lazy" decoding="async"
                                                [class.is-loaded]="!imagePending(item)"
                                                (load)="onImageLoad(item)" (error)="onImageError(item)" />
                                        </span>
                                    } @else {
                                        <span class="no-thumb" [ngbTooltip]="'admin_no_image' | translate" container="body">—</span>
                                    }
                                </td>
                                <td class="code">{{ item.code }}</td>
                                <td>{{ item.name || '—' }}</td>
                                <td class="slug">{{ item.slug }}</td>
                                <td class="num-col">{{ specCount(item) }}</td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn" (click)="viewPublic(item)"
                                        [ngbTooltip]="'admin_equipment_action_view_public' | translate" container="body">
                                        <fa-icon [icon]="faUpRightFromSquare"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn" (click)="openEdit(item)" [ngbTooltip]="'admin_action_edit' | translate" container="body">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(item)" [ngbTooltip]="'admin_action_delete' | translate" container="body">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
